import "../index.js";
import {apps} from "../index.js";
import type {AdjustPayload} from "./adjustPayload.js";
import type {FirebasePayload} from "./firebasePayload.js";
import type { NexusResult, OttoNexus} from "@otto-ec/global-resources/nexus";
import type { SmartBannerInfo } from "./smartbanner/smartBannerInfo.js";
export type { SmartBannerInfo };

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export type TrackFirebaseResult =
  | { success: true }
  | { validation_error: Record<string, string> };

export type ThirdpartyTrackingRaw = {
    /**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
    trackAdjust(adjustPayload: AdjustPayload): NexusResult<Promise<void>>;

    /**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
    trackFirebase(firebasePayload: FirebasePayload): NexusResult<Promise<TrackFirebaseResult>>;

    /**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
    shouldDisplaySmartAppBannerWithTracking(): NexusResult<SmartBannerInfo>;
}

export type ThirdpartyTracking = OttoNexus["apps"]["thirdpartyTracking"]

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export const thirdpartyTracking: ThirdpartyTracking = apps.thirdpartyTracking;

/**
 *
 */
export const trackAdjust: ThirdpartyTracking["trackAdjust"] = thirdpartyTracking.trackAdjust;

/**
 *
 */
export const trackFirebase: ThirdpartyTracking["trackFirebase"] = thirdpartyTracking.trackFirebase;

/**
 *
 */
export const shouldDisplaySmartAppBannerWithTracking: ThirdpartyTracking["shouldDisplaySmartAppBannerWithTracking"] = thirdpartyTracking.shouldDisplaySmartAppBannerWithTracking;


